import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { HttpHeaderConstants } from '@r1-compass-library/constants';
import { PlayError } from '@r1-compass-library/models/reporting/reporting-data.model';
import { PlayErrorReportingSearch } from '@r1-compass-library/models/reporting/reporting-search.model';
import { catchError, Observable, of, retry } from 'rxjs';
import { PlayReportingService } from './play-reporting.service';
import { Environment } from '@r1-compass-library/environments/environment';
import { PlayErrorSearch } from '@r1-compass-library/models/search/play-error-search.model';

@Injectable({
    providedIn: 'root',
})
export class PlayErrorService extends PlayReportingService {
    readonly #http = inject(HttpClient);

    private ERROR_DETAIL_URL: string = Environment.baseUrl + '/frontend/play-errors';

    constructor() {
        super();
    }

    getErrorDetails(search: PlayErrorSearch): Observable<PlayError[]> {
        const customHttpOptions = {
            headers: new HttpHeaders({ ...HttpHeaderConstants.defaultHeaders }),
            params: new HttpParams({}),
        };
        this.addSearchParams(search, customHttpOptions);
        return this.#http.get<PlayError[]>(this.ERROR_DETAIL_URL, customHttpOptions).pipe(
            retry(0),
            catchError(() => {
                return of<PlayError[]>();
            })
        );
    }

    getErrorDetailsForReporting(search: PlayErrorReportingSearch): Observable<PlayError[]> {
        const customHttpOptions = {
            headers: new HttpHeaders({ ...HttpHeaderConstants.defaultHeaders }),
            params: new HttpParams({}),
        };
        this.addSearchParams(search, customHttpOptions);
        return this.#http.get<PlayError[]>(this.ERROR_DETAIL_URL, customHttpOptions).pipe(
            retry(0),
            catchError(() => {
                return of<PlayError[]>();
            })
        );
    }
}
